import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/jenkins_home/workspace/jl-archives-front-net/app/components/detail/index.tsx");
